<template>

  <div id="HearingPureToneTestHeadphone">

    <div class="HearingTest-test--part" >

      <div class="info-help" v-show="!started" >
        <div class="HearingTest-test--part" >

          <div class="HearingTest-test--title">تست تون خالص</div>
          <div class="HearingTest-test--text">این تست آهسته ترین صداهایی که یک شخص در فرکانس های مختلف میتواند بشنود را مشخص میکند.</div>
          <button class="HearingTest-test--button" style="display: block; float: none; margin: 0px auto;"  @click="startTest()"><span>شروع تست</span> &gt;</button>
        </div>
      </div>
      <div v-show="started">
        <div class="HearingTest-test--title "><icon name="volume-up"></icon>گوش {{ earSide === 'L' ? 'چپ' : 'راست' }}</div>
        <div class="HearingTest-test--text">وقتی صدا را شنیدید بر روی <strong>بله</strong> کلیک کنید</div>
        <div class="HearingTest-test--calibrationContainer">
          <div class="HearingTest-test--volumeContainer"></div>
          <div class="HearingTest-test--spinnerBubbles">
            <div class="HearingTest-test--playButtonContainer">
              <div data-frequency="ptFrequency1" class="HearingTest-test--frequency">
                <span v-show="loadingTone" ><icon name="spinner" pulse></icon></span>
                <span  v-show="!loadingTone">{{currTone}}<br><span style="font-size: 22px;">HZ</span></span>
              </div>
            </div>
            <div class="HearingTest-test--spinnerBubble" style="margin-right: 31px; margin-top: 92px;"></div>
            <div class="HearingTest-test--spinnerBubble" style="margin-right: 53px; margin-top: -17px;"></div>
            <div class="HearingTest-test--spinnerBubble" style="margin-right: 11px; margin-top: -26px;"></div>
            <div class="HearingTest-test--spinnerBubble" style="margin-right: 72px; margin-top: -17px;"></div>
            <div class="HearingTest-test--spinnerBubble" style="margin-right: -4px; margin-top: -34px;"></div>
            <div class="HearingTest-test--spinnerBubble" style="margin-right: 87px; margin-top: -17px;"></div>
            <div class="HearingTest-test--spinnerBubble" style="margin-right: -11px; margin-top: -36px;"></div>
            <div class="HearingTest-test--spinnerBubble" style="margin-right: 94px; margin-top: -17px;"></div>
            <div class="HearingTest-test--spinnerBubble" style="margin-right: -8px; margin-top: -37px;"></div>
            <div class="HearingTest-test--spinnerBubble" style="margin-right: 93px; margin-top: -17px;"></div>
            <div class="HearingTest-test--spinnerBubble" style="margin-right: 1px; margin-top: -36px;"></div>
            <div class="HearingTest-test--spinnerBubble" style="margin-right: 83px; margin-top: -17px;"></div>
            <div class="HearingTest-test--spinnerBubble" style="margin-right: 18px; margin-top: -30px;"></div>
            <div class="HearingTest-test--spinnerBubble" style="margin-right: 65px; margin-top: -17px;"></div>
            <div class="HearingTest-test--spinnerBubble" style="margin-right: 41px; margin-top: -23px;"></div>
          </div>

          <div class="HearingTest-test--volumeContainer"></div>
        </div>
        <div class="clearfix"></div>
        <div class="HearingTest-test--toneButton ng-binding" v-show="!nextBtn" @click="nextTest()">بله</div>
        <div class="HearingTest-test--toneButton red ng-binding" v-show="nextBtn" @click="startTest()">بعدی!</div>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>

</template>

<script>


    export default {
        name: 'HearingPureToneTestHeadphone',
        props: ['starting'],
        components: {
        },
        created() {
            //console.log(starting);
            this.curAudio = this.tones["500L"];

        },
        data () {

            return {
                curAudio: null,
                earSide: 'L',
                tones:{
                    '500L': new Audio(window.pure_tone_lr.tone500L) ,
                    '500R': new Audio(window.pure_tone_lr.tone500R) ,
                    '1000L': new Audio(window.pure_tone_lr.tone1000L) ,
                    '1000R': new Audio(window.pure_tone_lr.tone1000R) ,
                    '2000L': new Audio(window.pure_tone_lr.tone2000L) ,
                    '2000R': new Audio(window.pure_tone_lr.tone2000R) ,
                    '4000L': new Audio(window.pure_tone_lr.tone4000L) ,
                    '4000R': new Audio(window.pure_tone_lr.tone4000R) ,
                },
                currTone:500,
                curCounterTone:0,
                answers : [],
                intervals: null,
                timeCounter : 0,
                loadingTone: true,
                nextBtn: false,
                started : false,
                answered : false,
                volL: 0,
                volR: 0,
            }
        },
        methods:{
            startTest(){

                let self = this;

                this.started = true;

                this.nextBtn = false;

                clearInterval(this.intervals);

                this.timeCounter = 0;

                this.intervals = setInterval(function() {
                    //let volL =((self.curCounterTone <= 1) ? window.calibrationAnswers.data.leftSecond :window.calibrationAnswers.data.leftFirst)/ 100;


                    this.volL =(window.calibrationAnswers.data.leftFirst - window.calibrationAnswers.data.leftSecond)/ 100;
                    //let volR = ((self.curCounterTone <= 1) ? window.calibrationAnswers.data.rightSecond :window.calibrationAnswers.data.rightFirst)/ 100;
                    this.volR = (window.calibrationAnswers.data.rightFirst - window.calibrationAnswers.data.rightSecond)/ 100;

                    console.log(window.calibrationAnswers.data.leftFirst, window.calibrationAnswers.data.leftSecond, volL);
                    console.log(window.calibrationAnswers.data.rightFirst, window.calibrationAnswers.data.rightSecond, volR);

                    let volPlus = (self.earSide === 'L' ? volL : volR);
                    let volume = volPlus + ((self.curCounterTone > 1 ? (self.curCounterTone -1) : 0 ) / 20);

                    volume = volume > 1 ? 1 : volume;
                    console.log(volPlus,volume);
                    self.curAudio.volume = volume;
                    self.curAudio.play();

                    self.test += 1;

                    if (self.curAudio.readyState <= 2)
                        return false;

                    self.checkAudioForPlay();


                }, 100)

            },
            checkAudioForPlay(){
                this.loadingTone = false;

                this.nextBtn = false;
                // if timeCounter is 0 so play this audio
                if(this.timeCounter === 0) {
                    this.playAudio();
                }

                // plus timeCounter
                this.timeCounter += 100;

                // if 3 seconds is done. so next audio
                if(this.timeCounter >= 3000 ){
                    this.timeCounter = 0;
                    return false;
                }

            },
            playAudio(){

                this.curAudio.pause();
                this.curAudio.currentTime = 0;
                if(this.currTone === 4000 &&  this.curCounterTone === 4){if(!this.answered)
                    this.answers.push({
                        'tone':this.currTone+this.earSide,
                        'answer':0
                    });
                    this.saveAndNextStep();
                    return false;
                }
                if(this.curCounterTone === 4){
                    this.loadingTone = true;

                    if(!this.answered)
                        this.answers.push({
                            'tone':this.currTone+this.earSide,
                            'answer':0
                        });

                    this.answered = false;

                    this.currTone *= 2;
                    this.curAudio = this.tones[this.currTone+this.earSide];
                    this.curCounterTone = 0;
                    this.nextBtn = true;

                }

                let volume = (this.earSide === 'L' ?  this.volL :  this.volR) + ((this.curCounterTone > 1 ? (this.curCounterTone -1) : 0 ) / 20);
                volume = volume > 1 ? 1 : volume;

                this.curAudio.volume = volume;
                this.curAudio.play();
                this.curCounterTone++;
            },
            nextTest(){

                this.answered = true;
                this.loadingTone = true;
                // mines 1 because  this.curCounterTone is always plussed 1
                //console.log("called! nextTest -->  ",this.currTone,this.answers);

                this.answers.push({
                    'tone':this.currTone+this.earSide,
                    'answer':this.curCounterTone
                });

                this.curCounterTone = 4;

                this.startTest();

            },
            saveAndNextStep(){

                this.loadingTone = true;
                this.timeCounter = 0;
                if(this.earSide === 'L'){
                    this.earSide = 'R';
                    this.currTone = 500;
                    this.curCounterTone = 0;
                    this.curAudio = this.tones["500R"];

                    this.nextBtn = true;
                    //this.startTest();
                    //console.log("GO Right");

                }else {
                    clearInterval(this.intervals);
                    /// save and go next
                    //console.log('PureToneAnswers', this.answers);
                    window.PureToneAnswers = this.answers;
                    this.$parent.$router.replace('/speech_test');
                }
            }
        }
    }
</script>

<style scoped>
  #PureToneTest{
    margin: 40px 0;
    text-align: center;
    padding: 0 10px 30px;
  }
  #PureToneTest button{
    text-align: center;
    cursor: pointer;
    border: none;
    float: right;
    width: 34%;
    margin: 0 8%;
    padding-top: 12px;
    padding-bottom: 10px;
    background-color: #00b7c6;
    font-weight: normal;
    font-style: normal;
    font-size: 24px;
    line-height: 20px;
    color: #fff;
    -webkit-box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.15);
    -moz-box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.15);
    box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.15);
  }@media (max-width: 599px) {
    #PureToneTest button{
      width: 90%;
    }
  }
  .HearingTest-test--title {
    text-align: center;
    margin-bottom: 10px;
    font-weight: normal;
    font-style: normal;
    font-size: 54px;
    line-height: 52px;
    color: #00b7c6;
  }
  .HearingTest-test--text {
    text-align: center;
    margin-bottom: 20px;
    font-weight: normal;
    font-style: normal;
    font-size: 16px;
    line-height: 22px;
    color: #000;
  }
  .HearingTest-test--calibrationContainer {
    display: block;
    padding: 15px 0 0;
    position: relative;
    height: 150px;
    text-align: center;
    width: 100px;
    margin: 0 auto;
  }

  .HearingTest-test--calibrationContainer .HearingTest-test--volumeContainer {
    float: left;
    width: 100px;
    margin-top: 18px;
  }
  .HearingTest-test--calibrationContainer .HearingTest-test--spinnerBubbles {
    width: 100px;
    height: 100px;
    margin-top: 10px;
    position: absolute;
  }
  .HearingTest-test--calibrationContainer .HearingTest-test--spinnerBubbles .HearingTest-test--playButtonContainer {
    position: absolute;
    width: 76px;
    height: 76px;
    margin: 11px 12px 0 0;
    background-color: #b5be00;
    border-radius: 100px;
    cursor: pointer;
    z-index: 5;
    box-shadow: 0px 0px 1px;
  }
  .HearingTest-test--calibrationContainer .HearingTest-test--spinnerBubbles .HearingTest-test--playButtonContainer .HearingTest-test--frequency {
    margin-top: 18px;
    font-weight: normal;
    font-style: normal;
    font-size: 32px;
    line-height: 22px;
    color: #fff;
    text-align: center;
  }
  .HearingTest-test--calibrationContainer .HearingTest-test--spinnerBubbles .HearingTest-test--spinnerBubble {
    position: relative;
    background-color: #ffffff;
    border: 1px solid #231f20;
    height: 15px;
    width: 15px;
    border-radius: 15px;
    box-sizing: content-box;
    -webkit-box-sizing: content-box;
    -moz-box-sizing: content-box;
  }
  .HearingTest-test--toneButton {
    text-align: center;
    width: 120px;
    margin: 10px auto 0;
    cursor: pointer;
    background-color: #00b7c6;
    padding-top: 9px;
    padding-bottom: 7px;
    font-weight: normal;
    font-style: normal;
    font-size: 22px;
    line-height: 22px;
    color: #fff;
    -webkit-box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.15);
    -moz-box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.15);
    box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.15);
  }
</style>



// WEBPACK FOOTER //
// src/components/HearingTest/HearingPureToneTestHeadphone.vue